import React, { useCallback, useEffect, useState } from "react";

import { useParams, useHistory } from "react-router-dom";
import Swal from "sweetalert2";

import { FaDownload } from "react-icons/fa";

import {
  Flex,
  Button,
  useDisclosure,
  Link,
  Icon,
  SimpleGrid,
  Box,
} from "@chakra-ui/react";

import LoadingSpinner from "../../../components/LoadingSpinner";
import CadastrarVoluntarioModal from "./Cadastrar";
import Group from "./Group";
import Table from "./Table";

import VoluntariadoSAService from "../../../../main/services/VoluntariadoSAService";
import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";
import { API } from "../../../../main/config";
import { Permission, servicos } from "../../../../helpers/Funcionalidades";
import SemRegistros from "../../../components/SemRegistros";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { useAuthProvider } from "../../../../Context/AuthProvider";

const VoluntariadoServicoAcolhimento = () => {
  const { id } = useParams();
  const history = useHistory();
  const {
    setCadastrarVoluntariadoServ,
    setEditarVoluntariadoServ,
    cadastrarVoluntariadoServ,
    editarVoluntariadoServ,
  } = useAppContext();

  const {
    isOpen: isOpenCadastro,
    onOpen: onOpenCadastro,
    onClose: onCloseCadastro,
  } = useDisclosure();
  const { roleKeycloack, user } = useAuthProvider();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const [dataSA, setDataSA] = useState();

  const columns = [
    {
      Header: "Nome",
      accessor: "nomeVoluntariado",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Atividades Desenvolvidas",
      accessor: "voluntariadoAtividades",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Termo de Voluntariado",
      accessor: "anexoTermo",
      Cell: (props) => {
        return (
          <Flex justifyContent="center">
            {props.value && (
              <Link
                href={
                  props.value.pathAnexo.toString().includes(".png") ||
                  props.value.pathAnexo.toString().includes(".jpg") ||
                  props.value.pathAnexo.toString().includes(".jpeg") ||
                  props.value.pathAnexo.toString().includes(".pdf")
                    ? API + `/anexos/${props.value.id}/visualizar`
                    : API + `/anexos/${props.value.id}/download`
                }
                target="_blank"
              >
                <Icon
                  aria-label="Download"
                  color="#006064"
                  as={FaDownload}
                  boxSize="18px"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            )}
          </Flex>
        );
      },
    },
  ];

  const handleGetVoluntariado = useCallback(() => {
    setLoading(true);
    VoluntariadoSAService.getVoluntariosSA(id)
      .then((res) => {
        setLoading(false);
        setData(res.data);
        if (res.data) {
          if (res.data.length === 1) {
            history.push(`/servico-acolhimento/visualizar-voluntariado/${id}`);
          }
        }
      })
      .catch((erro) => {
        setLoading(false);
      });
  }, [history, id]);

  useEffect(() => {
    handleGetVoluntariado();

    ServicoAcolhimentoService.getServicoAcolhimento(id)
      .then((res) => {
        setDataSA(res.data);
        if (res.data.tipoServicoAcolhimento.regime === "SAF") {
          Swal.fire({
            title: "Atenção!",
            text: "Este Serviço de Acolhimento não pode acessar essa informação!",
            icon: "warning",
            confirmButtonText: "Fechar",
            confirmButtonColor: "#169499",
          }).then(() => {
            history.push(`/servico-acolhimento/${id}`);
          });
        }
      })
      .catch((error) => console.log(error));
  }, [handleGetVoluntariado, history, id]);

  const handleCloseCadastroModal = () => {
    handleGetVoluntariado();
    onCloseCadastro();
  };

  return !loading ? (
    <>
      <Flex
        flexDir="column"
        bgColor="#FFF"
        mt="25px"
        borderRadius="16px"
        py="15px"
        px="25px"
        position={"relative"}
      >
        <Permission
          roleKeycloack={roleKeycloack}
          func={servicos.voluntariadoCadastrar}
          id={dataSA?.idPessoaJuridica}
          user={user}
        >
          <Button
            id="button-cadastrar"
            color="#FFF"
            backgroundColor="#169499"
            fontWeight={700}
            fontSize="15px"
            lineHeight="21.6px"
            position={"absolute"}
            right={4}
            w={{ base: "30%", lg: "17%" }}
            alignSelf="flex-end"
            _hover={{ bg: "#169499" }}
            onClick={onOpenCadastro}
          >
            Cadastrar
          </Button>
        </Permission>

        <Group title="Voluntariado">
          {(data ? data.length > 0 : false) ? (
            <Box mt={4}>
              <Table
                data={data}
                columns={columns}
                handleGetVoluntariado={handleGetVoluntariado}
                idSA={id}
                setEditarVoluntariadoServ={setEditarVoluntariadoServ}
                editarVoluntariadoServ={editarVoluntariadoServ}
                roleKeycloack={roleKeycloack}
                user={user}
                idPJ={dataSA?.idPessoaJuridica}
              />
            </Box>
          ) : (
            <Box mt={2}>
              <SemRegistros buttonVisible={true} half />
            </Box>
          )}
        </Group>
      </Flex>

      {isOpenCadastro && (
        <CadastrarVoluntarioModal
          isOpen={isOpenCadastro}
          onOpen={onOpenCadastro}
          onClose={handleCloseCadastroModal}
          cadastrarVoluntariadoServ={cadastrarVoluntariadoServ}
          setCadastrarVoluntariadoServ={setCadastrarVoluntariadoServ}
        />
      )}
      <SimpleGrid
        mt="30px"
        columns={{ base: 1, sm: 2, lg: 5 }}
        spacing="20px"
        dir="rtl"
      ></SimpleGrid>
    </>
  ) : (
    <Flex w="100%" mt="25%" justifyContent="center">
      <LoadingSpinner />
    </Flex>
  );
};

export default VoluntariadoServicoAcolhimento;
